import script from "./CMSUsers.vue?vue&type=script&lang=ts&setup=true"
export * from "./CMSUsers.vue?vue&type=script&lang=ts&setup=true"

import "./CMSUsers.vue?vue&type=style&index=0&id=864064f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-864064f8"]])

export default __exports__